export default "__VITE_ASSET__7a6b97e1__"